import React, {
    useCallback,
    useEffect,
    useRef,
} from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import * as Yup from 'yup';



import { Input, Select, InputText, Hidden } from '~/components/Form';
import * as S from './styles'

import { updateVazao } from '~/store/modules/equipamento/actions';



export default function EquipamentoVazao({
    data,
    sending,
    visible,
    toggleDisabled,
    close
}) {

    const dispatch = useDispatch()

    const reduxData = useSelector(state => state.equipamento)
    const formRef = useRef(null);


    const handleSubmit = useCallback(async (param) => {
        try {
            toggleDisabled(true)
            const schema = Yup.object().shape({

                veva_vazao_maxima: Yup.number()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório')
                    .min(0, 'O valor deve ser maior que 0')
                    .max(9999, 'Valor máximo 9999'),


            });

            await schema.validate(param, {
                abortEarly: false,
            });

            const objSend = {
                codVeiculo: param.veic_cod_veic,
                codEmpresa: param.empe_cod_emp,
                vazao: Number(param.veva_vazao_maxima)
            }

            await dispatch(updateVazao(objSend, reduxData.params))

            toggleDisabled(false)
            close()

        } catch (err) {
            toggleDisabled(false)
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message.replace(
                        `${error.path} `,
                        ''
                    );
                });
                formRef.current.setErrors(validationErrors);
            } else {
                toast.error(err)
            }
        }

    }, [formRef, reduxData])

    useEffect(() => {
        if (sending) formRef.current.submitForm();
    }, [sending]);

    return (

        <S.ModalForm
            ref={formRef}
            initialData={{
                ...data
            }}
            onSubmit={handleSubmit}>
            <Input name="veic_cod_veic" label="Veículo" disabled />
            <Input name="empe_desc" label="Empresa" disabled />
            <Input name="veva_vazao_maxima" label="Vazão máxima (L/min)" type="number" inputProps={{ min: 1, max: 9999 }} />

            <Hidden name="empe_cod_emp" />


        </S.ModalForm>


    )
}

EquipamentoVazao.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    sending: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    toggleDisabled: PropTypes.func.isRequired,
};
